import React from "react";
import "./navigator.scss";
import { Category } from "../../../../application/domain/help/help-entity";
import { HelpIcon } from "../../../../application/domain/help/const";
import { useNavigatorController } from "./use-navigator-controller";

export type NavigatorProps = {
  categoryList: Category[];
  productId: string;
};

export type NavigatorContentProps = {
  category: Category;
  productId: string;
};

const NavigatorContent: React.FC<NavigatorContentProps> = (props) => {
  const Icon = HelpIcon[props.category.id];
  return props.category.metadata.isvisibleinnavigation &&
    props.category.metadata.children.length > 0 ? (
    <div className="category-box">
      <p className="category-title">
        {Icon ? <Icon /> : null}
        {props.category.title}
      </p>
      <ul className="category-children">
        {props.category.metadata.children.map((child) => (
          <li key={child.slug}>
            <a href={`/help/contents/${child.slug}`} className="contents-title">
              {child.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};

export const Navigator: React.FC<NavigatorProps> = (props) => {
  const { filteredCategoryList } = useNavigatorController(props);
  return (
    <div className="help-navigator-container">
      {filteredCategoryList.map((category) => (
        <NavigatorContent
          key={category.id}
          category={category}
          productId={props.productId}
        />
      ))}
    </div>
  );
};
